/******************************************************************************************
 *	Customer Entity
 ******************************************************************************************/
(function() {
  

  angular.module('rcEntities.customer', []).factory(
    'CustomerModel',
    /* @ngInject */
    function(_) {
      function CustomerModel(data) {
        _.assign(this, data);
      }

      // eslint-disable-next-line lodash/prefer-constant
      CustomerModel.prototype.needsContractOwner = function() {
        return false;
      };

      return CustomerModel;
    }
  );
})();
